module.exports = __webpack_public_path__ + "static/img/title-wenzi.07bbfe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/2020/pc/title-wenzi.png
// module id = n7Vo
// module chunks = 69